import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ModulesContainer',
    setup() {
        return {};
    },
});
